import { updateFuel } from "auth/store/action";
import { API_STATUS } from "core-lib/constants/network";
import { useDispatch, useSelector } from "react-redux";
import fetchBarrelBalance from "core-lib/services/fetchBarrelBalance";

type ResultType = {
  balance: number;
  apiStatus: string;
  getPetrolBalance: () => void;
};

export function useFuelBalance(): ResultType {
  const dispatch = useDispatch();
  const { fuelBalance } = useSelector((state: any) => state?.auth);

  // get barrel balance and set in redux
  const getPetrolBalance = async () => {
    const { response, error } = await fetchBarrelBalance();
    dispatch(
      updateFuel({
        fuelBalance: {
          ...fuelBalance,
          apiStatus: API_STATUS.in_progress,
        },
      })
    );
    if (response) {
      dispatch(
        updateFuel({
          fuelBalance: {
            apiStatus: API_STATUS.success,
            balance: response?.fuelBalance,
          },
        })
      );
    } else if (error) {
      dispatch(
        updateFuel({
          fuelBalance: {
            apiStatus: API_STATUS.failure,
            balance: 0,
          },
        })
      );
    }
  };

  return {
    balance: fuelBalance?.balance,
    apiStatus: fuelBalance?.apiStatus,
    getPetrolBalance,
  };
}
